import React, { memo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { PublishType, CreateEventFormData, CreateEventFormErrors } from '@/types/admin/createEvent';
import { PublishOptionsSectionBase } from '@/components/common/admin/shared/PublishOptionsSectionBase';

interface PublishOptionsSectionProps {
  formData: CreateEventFormData;
  errors: CreateEventFormErrors;
  onPublishTypeChange: (type: PublishType) => void;
  onPublishTimePress: () => void;
}

export const PublishOptionsSection = memo<PublishOptionsSectionProps>(({ 
  formData,
  errors,
  onPublishTypeChange,
  onPublishTimePress,
}) => {
  return (
    <PublishOptionsSectionBase
      title="When do you want to publish?"
      copy={{
        publishNow: { label: 'Publish Now', description: 'Event will be visible to residents immediately' },
        draft: { label: 'Save as Draft', description: 'Event will be saved but not visible to residents' },
        scheduled: { label: 'Schedule for Later', description: 'Choose when the event becomes visible to residents' },
        scheduledFieldLabel: 'Publish Time *',
      }}
      publishType={formData.publishType}
      publishTime={formData.publishTime || null}
      errorText={errors.publishTime}
      onPublishTypeChange={onPublishTypeChange}
      onPublishTimePress={onPublishTimePress}
    />
  );
});

PublishOptionsSection.displayName = 'PublishOptionsSection';

const styles = StyleSheet.create({
});
